import React from 'react';
import { ViewportContext } from '../Context/viewport';


const useViewport = () => {
  const { width, height } = React.useContext(ViewportContext);
  return { width, height };
};

export default useViewport;